import './TAC.scss'
import Navbar from '../landing/components/Navbar'
import { useNavigate } from 'react-router-dom'
import TACimg from '../../assets/images/TAC.png'
import wave from '../../assets/images/ph_waves-thin.png'
import star from '../../assets/images/Vector 166.png'
import { Icon } from '@iconify/react'
import FaqsTACData from '../../assets/data/FaqsTACData'
import { useState } from 'react'
import Logo from '../../assets/images/logo-white.png'

const TAC = () => {
  const navigate = useNavigate()
  const [selectedQuestion, setSelectedQuestion] = useState(0)

  return (
    <div className='terms-page'>
      <Navbar use='tac' />

      <div className='hero'>
        <div className='hero-wrapper flex flex-wrap justify-between'>
          <div className='left'>
            <div className='left-wrap'>
              <h1>
                QC EXPRESS <br /> TERMS AND CONDITIONS
              </h1>
              <p>
                By using our services, you agree to our terms and conditions,
                which outline the rights and responsibilities for both parties.
                We encourage you to review them to ensure a smooth and
                transparent experience with our logistics and delivery
                solutions.
              </p>
              <img src={wave} alt='wave' className='wave' />
            </div>
          </div>
          <div className='right'>
            <img src={TACimg} alt='programmer' />
          </div>
        </div>
      </div>

      <div className='terms-container'>
        <div className='breadcrumb'>
          <span>HOME</span>/
          <span className='active'> TERMS AND CONDITIONS</span>
        </div>

        <img src={star} alt='' className='star' />

        <div className='terms-box'>
          <h2>QC Express Terms and Conditions of Carriage.</h2>
          <p>
            (“Terms and Conditions”) When ordering QC Express’s services you, as
            “Shipper”, are agreeing, on your behalf and on behalf of the
            consignee of the Shipment (“Consignee”) and anyone else with an
            interest in the Shipment that these Terms and Conditions shall
            apply.
            <br />
            “Shipment” means all documents or parcels that travel under one
            waybill and which may be carried by any means QC Express chooses,
            including air, road or any other carrier. A “waybill” shall include
            any Shipment identifier or document produced by QC Express or
            Shipper automated systems such as a label, barcode, waybill or
            consignment note as well as any electronic version thereof. Every
            Shipment is transported on a limited liability basis as provided
            herein. If Shipper requires greater protection, then insurance may
            be arranged at an additional cost. (Please see below for further
            information). “QC Express” means any member of the QC Express
            Network.
          </p>

          <h2>Customs Clearance and Regulatory Compliance.</h2>
          <p>
            QC Express may perform any of the following activities on Shipper's
            or Consignee’s behalf in order to provide services: (1) complete any
            documents, amend product or service codes and advance any duties,
            taxes or other regulatory charges required under applicable laws and
            regulations ("Customs Duties"), (2) act as Shipper’s or Consignee's
            true and lawful agent or designate a customs broker to perform
            export control and customs clearance and (3) redirect the Shipment
            to Consignee's customs broker or other address upon request by any
            person who QC Express believes in its reasonable opinion to be
            authorized. Shipper or Consignee will provide any extra
            authorization required by applicable law for QC Express to clear a
            Shipment.
          </p>

          <h2>Unacceptable Shipments.</h2>
          <p>
            A Shipment is deemed unacceptable if: it contains complete firearms,
            ammunition, explosives, explosive devices or test pieces, air guns,
            replica or imitation firearms; counterfeit goods; cash; bullion (of
            any precious metal); live animals, prohibited animal parts or
            remains, such as ivory; human remains or ashes; loose precious or
            semi-precious stones; cannabis or its derivatives; or illegal goods,
            such as narcotics or other illegal drugs, it is classified as
            hazardous material, dangerous goods, prohibited or restricted
            articles under ADR (European Road Transport Regulation on dangerous
            goods) or by IATA (International Air Transport Association), ICAO
            (International Civil Aviation Organization), or other relevant
            organization ("Dangerous Goods"), it contains any other item which
            QC Express cannot carry safely or legally, the address is incorrect
            or not properly marked or its packaging is defective or inadequate
            to ensure safe transportation with ordinary care in handling,
            Shipper, Consignee or any other party with a direct or indirect
            interest in the Shipment is listed on any applicable sanctions lists
            as a denied or restricted party.
          </p>

          <h2>Deliveries and Undeliverables.</h2>
          <p>
            Shipments cannot be delivered to PO boxes or postal codes. Shipments
            are delivered to the Consignee's address given by Shipper but not
            necessarily to the named Consignee personally. Shipments to
            addresses with a central receiving area will be delivered to that
            area. <br />
            QC Express may notify Consignee of an upcoming delivery or a missed
            delivery. Consignee may be offered alternative delivery options such
            as delivery on another day, no signature required, redirection or
            collection at a QC Express Service Point. <br />
            If the Shipment is deemed to be unacceptable as described in Section
            2, it has been undervalued for customs purposes, Consignee cannot be
            reasonably identified or located, or Consignee refuses delivery or
            to pay Customs Duties or other Shipment charges, QC Express shall
            use reasonable efforts to return the Shipment to Shipper. This shall
            be at Shipper's cost. If it is not possible to return the Shipment,
            it may be released, abandoned, disposed of or sold without incurring
            any liability whatsoever to Shipper or anyone else. QC Express shall
            have the right to destroy any Shipment if QC Express is prevented by
            any law or law enforcement agency from returning it in whole or in
            part to Shipper, as well as any Shipment of Dangerous Goods.
          </p>

          <h2>Inspections.</h2>
          <p>
            QC Express has the right to open and inspect a Shipment without
            notice for safety, security, customs or other regulatory reasons.
          </p>

          <h2>Shipment Charges, Duties and Fees.</h2>
          <p>
            QC Express's Shipment charges are calculated according to the higher
            of actual or volumetric weight per piece and any piece may be
            re-weighed and re-measured by QC Express to confirm this
            calculation. <br />
            Payment of Customs Duties and other charges due as indicated on QC
            Express's website in the receiving country may be requested from
            Consignee prior to delivery. This includes a fee if QC Express uses
            its credit with the Customs Authorities or pays any Customs Duties
            on Consignee's behalf. Shipper shall pay or reimburse QC Express for
            all Customs Duties and other charges due for services provided by QC
            Express or incurred by QC Express on Shipper's or Consignee's behalf
            if Consignee has failed to pay.
          </p>

          <h2>QC Express's Liability.</h2>
          <p>
            QC Express's liability in respect of any one Shipment transported by
            air (including ancillary road transport or stops en route) is
            limited by the Montreal Convention or the Warsaw Convention as
            applicable, or in the absence of such Convention, to the lower of
            (i) the current market or declared value, or (ii) 22 Special Drawing
            Rights per kilogram (approximately $US 30.00 per kilogram). Such
            limits shall also apply to all other forms of transportation, except
            where Shipments are carried only by road, when the limits below
            apply. For cross border Shipments transported by road, QC Express's
            liability is or shall be deemed to be limited by the Convention for
            the International Carriage of Goods by Road (CMR) to the lower of
            (i) current market value or declared value, or (ii) 8.33 Special
            Drawing Rights per kilogram (approximately $US 11.00 per kilogram).
            Such limits will also apply to national road transportation in the
            absence of any mandatory or lower liability limits in the applicable
            national transport law. If Shipper regards these limits as
            insufficient it must make a special declaration of value and request
            insurance as described in Section 8 or make its own insurance
            arrangements. QC Express's liability is strictly limited to direct
            loss and damage to a Shipment only and to the per kilogram limits in
            this Section 6. All other types of loss or damage are excluded
            (including but not limited to lost profits, income, interest, future
            business), whether such loss or damage is special or indirect, and
            even if the risk of such loss or damage was brought to QC Express's
            attention. QC Express will make every reasonable effort to deliver
            the Shipment according to QC Express's regular delivery schedules,
            but these schedules are not binding and do not form part of the
            contract. QC Express is not liable for any damages or loss caused by
            delay, but for certain Shipments, Shipper may be able to claim
            limited delay compensation under the Money Back Guarantee terms and
            conditions.
          </p>

          <h2>Claims.</h2>
          <p>
            All claims must be submitted in writing to QC Express within thirty
            (30) days from the date that QC Express accepted the Shipment,
            failing which QC Express shall have no liability whatsoever. Claims
            are limited to one claim per Shipment, settlement of which will be
            full and final settlement for all loss or damage in connection
            therewith. Shipment Insurance Express may be able to arrange
            insurance for loss of or damage to the Shipment, covering the full
            value of the goods, provided that Shipper so instructs QC Express in
            writing, including by completing the insurance section of the
            waybill or using QC Express's automated systems and pays the
            applicable premium. Shipment insurance does not cover indirect loss
            or damage, or loss or damage caused by delays. Circumstances Beyond
            QC Express's Control QC Express is not liable for any loss or damage
            arising out of circumstances beyond QC Express's control. These
            include but are not limited to electrical or magnetic damage to, or
            erasure of, electronic or photographic images, data or recordings;
            any defect or characteristic related to the nature of the Shipment,
            even if known to QC Express; any act or omission by a person not
            employed or contracted by QC Express - e.g. Shipper, Consignee,
            third party, customs or other government official; third party
            cyber-attacks or other information security related threats; "Force
            Majeure" - e.g. earthquake, cyclone, storm, flood, fog, war, plane
            crash, embargo, riot, epidemic, pandemic, civil commotion, or
            industrial action. Shipper's Representations, Warranties and
            Indemnities Shipper shall indemnify and hold QC Express and its
            directors, officers, employees and agents harmless from and against
            all and any liabilities, losses and damages arising out of Shipper’s
            failure to comply with the following warranties and representations:
            the Shipment is acceptable for transport under Section 2 above, the
            Shipment was prepared in secure premises by reliable persons and was
            protected against unauthorized interference during preparation,
            storage and any transportation to QC Express, Shipper has complied
            with applicable export control, sanctions, customs laws and
            regulations or other applicable regulatory requirements and
            restrictions related to the import, export, transit or transfer of
            goods, Shipper has declared to QC Express any controlled dual-use or
            military goods subject to government authorizations contained in the
            Shipment, Shipper has provided all information, permits, licenses or
            other government authorizations and documents, as required by
            applicable law or upon request from QC Express, and all information,
            permits, licenses or other government authorizations and documents
            provided by Shipper or its representatives are true, complete and
            accurate, including the value and description of the goods and
            Shipper and Consignee information, when providing personal data to
            QC Express, Shipper has complied with its legal obligations to
            process and share this data, including informing the affected
            individuals that personal data, including Consignee’s email address
            and mobile phone number, is required for transport, customs
            clearance and delivery.
          </p>

          <h2>Routing.</h2>
          <p>
            Shipper agrees to all routing and diversion, including the
            possibility that the Shipment may be carried via intermediate
            stopping places.
          </p>

          <h2>Governing Law.</h2>
          <p>
            Any dispute arising under or in any way connected with these Terms
            and Conditions shall be subject to the non-exclusive jurisdiction of
            the courts of, and governed by the law of the country of origin of
            the Shipment and Shipper irrevocably submits to such jurisdiction,
            unless contrary to applicable law. Severability The invalidity or
            unenforceability of any provision shall not affect any other part of
            these Terms and Conditions.
          </p>
        </div>
      </div>

      <div className='faqs'>
        <div className='wrapper'>
          <div className='top'>
            <h1 className='gradient-text'>frequently asked questions(FAQs)</h1>
            <p>
              Find answers to common inquiries in our Frequently Asked Questions
              (FAQ) section.
            </p>
          </div>
          <div className='faq-list'>
            {FaqsTACData.map((data, index) => (
              <div className='faq' key={index}>
                <div
                  className='question flex justify-between'
                  onClick={() => setSelectedQuestion(index)}
                >
                  <h3>{data.question}</h3>
                  <div>
                    {selectedQuestion === index ? (
                      <Icon icon='akar-icons:chevron-up' />
                    ) : (
                      <Icon icon='akar-icons:chevron-down' />
                    )}
                  </div>
                </div>
                {selectedQuestion === index && (
                  <div className='answer'>
                    <p>{data.answer}</p>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className='footer'>
        <div className='wrapper'>
          <div className='flex justify-between flex-wrap'>
            <div className='card logo'>
              <img src={Logo} alt='' />
              <p>
                Your trusted partner in getting goods where they need to be,
                fast and safe.
              </p>
            </div>

            <div className='card'>
              <h3>Contact Us</h3>
              <div className='flex'>
                <div>
                  <div className='icon'>
                    <Icon icon='mdi:location' />
                  </div>
                </div>
                <div className='text'>
                  <p>Location:</p>
                  <p>
                    14A Olatunji Close, Off Continental Way, Ikosi GRA IV,
                    Magodo, Lagos-Nigeria.
                  </p>
                </div>
              </div>
              <div className='flex'>
                <div>
                  <div className='icon'>
                    <Icon icon='ic:baseline-phone' />
                  </div>
                </div>
                <div className='text'>
                  <p>Phone Number:</p>
                  <p>
                    +234 912 049 9852–7, +234 802 0549 655, +234 802 290 2446
                  </p>
                </div>
              </div>
              <div className='flex'>
                <div>
                  <div className='icon'>
                    <Icon icon='bxs:envelope' />
                  </div>
                </div>
                <div className='text'>
                  <p>Email:</p>
                  <p>customercare@quartzclassic.com</p>
                </div>
              </div>
            </div>
            <div className='card'>
              <h3 className='newsletter-h3'>SUBSCRIBE TO OUR NEWSLETTER</h3>
              <input type='text' placeholder='Enter your email' />
              <br />
              <button onClick={() => navigate('/')}>Subscribe</button>
              <div className='socials'>
                <a
                  href='https://www.instagram.com/qc_express?igsh=NjhyYWZtNm1lN3Rk'
                  target='_blank'
                  rel='noopener noreferrer'
                >
                  <Icon icon='akar-icons:instagram-fill' />
                </a>
                <Icon icon='akar-icons:facebook-fill' />
                <a
                  href='https://x.com/qc_express'
                  target='_blank'
                  rel='noopener noreferrer'
                >
                  <Icon icon='akar-icons:twitter-fill' />
                </a>
              </div>
            </div>
          </div>
          <hr />
          <p className='footer-p'>&copy; QC Express. All rights reserved.</p>
        </div>
      </div>
    </div>
  )
}

export default TAC
